import React, { useState } from 'react';
import { read, utils, writeFile } from 'xlsx';
import icAlert from '../../../assets/svg/icons/ic-alert.svg';

const UploadCsv = ({ onCsvUpload, getGlobalVariable, isValidData }) => {

    const [fileContent, setFileContent] = useState('');
    const [displayText, setDisplayText] = useState(`Click here to upload your Excel file`);
    const [selectedFile, setSelectedFile] = useState(null);
    const [duplicateRows, setDuplicateRows] = useState([]);
    const [isValidDt, setIsValidate] = useState(false)

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        setSelectedFile(file);

        reader.onload = (e) => {
            const content = e.target.result;
            setFileContent(content);
            setDisplayText(file.name);

            // Parse the uploaded spreadsheet using xlsx
            const workbook = read(content, { type: 'binary' });

            // Assuming there is only one sheet in the workbook
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            // Extract data from the sheet (assuming it's in A1 format)
            const data = utils.sheet_to_json(sheet);

            // Check for duplicate rows
            const duplicates = findDuplicateRows(data);
            setDuplicateRows(duplicates);

            duplicates.length == 0 ? isValidData(true) : isValidData(false)

            onCsvUpload(data);
        };

        reader.readAsBinaryString(file);

    };

    // Function to find duplicate rows
    const findDuplicateRows = (data) => {
        const seen = {};
        const duplicates = [];

        for (let i = 0; i < data.length; i++) {
            const row = data[i];
            const rowString = JSON.stringify(row);

            if (seen[rowString]) {
                duplicates.push(row);
            } else {
                seen[rowString] = true;
            }
        }

        return duplicates;
    };

    return (
        <div className='my-2 w-75'>
            <div className='input-group input-bg d-flex rounded-pill '>
                <div className='d-flex w-75'>
                    <div className='bg-transparent w-100 form-control input-bg file'>
                        <label htmlFor='fileInput' className='fileInputLabel w-100'>
                            {displayText}
                        </label>
                        <input
                            id='fileInput'
                            className='bg-transparent fileInput input-bg file w-100'
                            type='file'
                            accept='.csv, .xls, .xltx, .xlsx'
                            onChange={handleFileUpload}
                            style={{ display: 'none' }}
                        />
                    </div>
                </div>
                <label role='button' htmlFor='fileInput' className='fileInputLabel ms-auto rounded-pill btn btn-success m-2 text-white'>
                    Upload
                </label>
            </div>
            <p className='mt-4'>
                As per the template you selected. Please make sure your Excel file includes, for each request, the following columns:
                <span className='fw-bold'> {getGlobalVariable.toString().replaceAll(',', ', ')}.</span>
            </p>
            {duplicateRows.length > 0 &&
                <div className="container-fluid p-0 m-0">
                    <h1 className='text-start w-100 title my-4'>Here is a sample from the file you uploaded.</h1>
                    <table className="table">
                        <thead>
                            <tr>
                                {duplicateRows.length > 0 && Object.keys(duplicateRows[0]).map((key, index) => (
                                    <th className='table-head border-top-1 font-weight-bold' key={index}>{key}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {duplicateRows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {Object.values(row).map((value, cellIndex) => (
                                        <td className='font-weight-normal' key={cellIndex}>{value}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="row justify-content-center">
                        <div className="p-1 rounded-pill d-flex align-items-center bg-alert" role="alert">
                            <img className='p-1' src={icAlert} alt="" srcSet="" />
                            <span className='px-1'>The file you uploaded has duplicate phone numbers! Please upload a nnew one.</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default UploadCsv;
